<form [formGroup]="form">
  <div class="gap-lg grid" formArrayName="sousCaracteristiques">
    @for (form of sousCaracteristiques.controls; track $index; let idx = $index) {
      <div [formGroupName]="idx" hlmField>
        <label [for]="'nom-' + idx" hlmFieldLabel labelRequired>Nom de la sous-caractéristique {{ idx + 1 }}</label>
        <input [id]="'nom-' + idx" hlmInput type="text" formControlName="nom" />
        @if (form.get('nom')?.hasError('required') && form.touched) {
          <hlm-field-error>Merci de renseigner un nom</hlm-field-error>
        }
        @if (form.get('nom')?.hasError('notUnique')) {
          <hlm-field-error>Cette sous-caractéristique existe déjà.</hlm-field-error>
        }
      </div>
    }
    <app-button-add-new (click)="addSousCaracteristique()" label="Ajouter une autre sous-caractéristique" />
  </div>
</form>
